import { configureStore } from '@reduxjs/toolkit';
import bookingReducer from './reducers/bookingReducer';
import paymentReducer from './reducers/paymentCards'


export const store = configureStore({
  reducer: {
    bookingDetails: bookingReducer,
    payments: paymentReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const payments = (state: RootState) => state.payments
export const selectBooking = (state: RootState) => state.bookingDetails

